<template>
  <div>
    <b-card no-body class="pb-10 px-10">
      <AddAuthorPopup
        :isActive="isAddtestActive"
        :selectaddAuthor="selectaddAuthor"
        @close="handleAddAuthor(false)"
      />
      <EditAuthorPopup
        :isActive="isEditTestActive"
        :selectEditAuthor="selectEditAuthor"
        @close="handleEditAuthor"
      />
      <div class="flex justify-between items-center py-10">
        <div>
          <h2 class="text-2xl font-semibold">List of Authors</h2>

          <small class="text-muted">Manage all your authors here. </small>
        </div>

        <base-button
          outline
          class="px-6 py-1 mx-1"
          type="primary"
          @click="handleAddAuthor(true)"
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
            Author</span
          >
        </base-button>
      </div>
      <div class="flex gap-4">
        <div class="w-full">
          <b-input-group class="">
            <b-form-input
              class="border-none shadow-lg"
              type="text"
              v-model="search"
              placeholder="Enter Search...."
            ></b-form-input>

            <b-input-group-append>
              <b-button
                variant="white"
                class="flex items-center shadow-lg"
                aria-label="search"
                @click="getAuthor"
              >
                <feather-icon
                  class="cursor-pointer mr-2"
                  icon="SearchIcon"
                  svgClasses="w-4 h-4"
                ></feather-icon>
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <!-- <div class="w-1/4">
          <b-form-select
            v-model="selected"
            :options="options"
            placeholder="filter"
          ></b-form-select>
        </div> -->
      </div>
      <div class="mt-6">
        <el-table
          :data="tableData"
          class="table-responsive table-flush"
          header-row-class-name="thead-light table-th-color table-textcenter"
          border
        >
          <el-table-column
            label="Sr. No"
            type="index"
            :index="indexMethod"
            width="80px"
          >
          </el-table-column>
          <el-table-column prop="image" label="Image">
            <template slot-scope="scope">
              <img
                :src="
                  scope.row.image
                    ? `${$imageURL}/${scope.row.image}`
                    : require(`@/assets/images/AuthorImage.jpg`)
                "
                class="w-20 h-20"
                :alt="scope.row.name"
              />
            </template>
          </el-table-column>
          <el-table-column prop="name" label="Name"> </el-table-column>
          <el-table-column prop="designation" label="Bio">
            <template slot-scope="scope">
              {{ scope.row.designation ? scope.row.designation : "-" }}
            </template>
          </el-table-column>
          <el-table-column
            label="Actions"
            min-width="80px"
            class-name="text-center"
          >
            <template slot-scope="scope">
              <div class="flex justify-center items-center">
                <div class="flex" @click="handleEditAuthor(true, scope.row)">
                  <feather-icon
                    icon="Edit2Icon"
                    svgClasses="w-4 text-blue-600 cursor-pointer"
                    class="ml-2"
                  ></feather-icon>
                </div>
                <div class="flex" @click="handleDeleteAuthor(scope.row._id)">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5 text-red-600 cursor-pointer"
                    class="ml-2"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <b-card-footer class="py-4 d-flex justify-content-end">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Table, TableColumn } from "element-ui";
import AddAuthorPopup from "./components/AddAuthorPopup.vue";
import EditAuthorPopup from "./components/EditAuthorPopup1.vue";
import _ from "lodash";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    AddAuthorPopup,
    EditAuthorPopup,
  },
  data() {
    return {
      isAddtestActive: false,
      isEditTestActive: false,
      selectaddAuthor: {},
      selectEditAuthor: {},
      search: "",
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      tableData: [
        // {
        //   image: "2016-05-03",
        //   name: "Tom",
        //   address: "No. 189, Grove St, Los Angeles",
        //   designation: "manager",
        // },
      ],
    };
  },
  methods: {
    indexMethod(index) {
      return this.perPage * (this.currentPage - 1) + index + 1;
    },
    handleAddAuthor(val = false, item = {}) {
      this.isAddtestActive = val;
      this.selectaddAuthor = item;
    },
    handleEditAuthor(val = false, item = {}) {
      this.isEditTestActive = val;
      this.selectEditAuthor = item;
    },
    async handleDeleteAuthor(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData(id) {
      let loader;
      let payload = {
        authorId: id,
      };
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "cmsAuthor/deleteAuthor",
          payload
        );
        loader.close();
        if (data.code === 200) {
          await this.$swal({
            text: "Author information has been successfully deleted!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });
          this.getAuthor();
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
    async getAuthor() {
      let curPage = this.currentPage - 1;
      let payload = {
        limit: this.perPage,
        offset: curPage,
      };

      if (this.search !== "")
        Object.assign(payload, { search: this.search.trim() });

      try {
        let loader = this.$loading();
        const getAuthor = await this.$store.dispatch(
          "cmsAuthor/getAuthor",
          payload
        );
        // console.log(getAuthor);
        loader.close();
        this.totalRows = this.author.totalCount;
        let authorData = this.author.result;
        this.tableData = authorData;
      } catch (error) {
        console.log(error);
        loader.close();
      }
    },
  },
  watch: {
    isAddtestActive(val) {
      if (!val) {
        this.getAuthor();
      }
    },
    isEditTestActive(val) {
      if (!val) {
        this.getAuthor();
      }
    },
    async currentPage() {
      await this.getAuthor();
    },
    search: {
      handler: _.debounce(async function (val) {
        this.getAuthor();
      }, 500),
    },
  },
  computed: {
    ...mapState("cmsAuthor", {
      author: "author",
    }),
  },
  async mounted() {
    await this.getAuthor();
  },
};
</script>
